export default function getDefaultCurrency(): string {
  let currencyType = '';
  switch (process.env.NEXT_PUBLIC_DEFAULT_LOCALE) {
    case 'de':
    case 'fi':
    case 'en':
      currencyType = 'EUR';
      break;
    case 'sv':
      currencyType = 'SEK';
      break;
    case 'pl':
      currencyType = 'PLN';
      break;
    case 'no':
    default:
      currencyType = 'NOK';
      break;
  }
  return currencyType;
}
